import { router } from '@inertiajs/react'
import { useEffect, useState } from 'react'

function FlashAlert({ variant, message, onDismiss, textDark }) {
  if (!message) return null

  const className = [
    'alert',
    `alert-${variant}`,
    textDark ? 'text-dark' : '',
    'alert-dismissible',
    'fade',
    'show',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={className} role="alert">
      <h4 className="alert-heading mb-0">{message}</h4>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        onClick={onDismiss}
      ></button>
    </div>
  )
}

export default function Show({ gisRecord, notice, alert }) {
  const [flashNotice, setFlashNotice] = useState(notice)
  const [flashAlert, setFlashAlert] = useState(alert)

  useEffect(() => {
    if (notice) setFlashNotice(notice)
    if (alert) setFlashAlert(alert)
  }, [notice, alert])

  const shareholders = gisRecord?.shareholders || []

  return (
    <div className="container-fluid">
      <div className="header">
        <div className="header-body">
          <div className="row align-items-end">
            <div className="col">
              <h6 className="header-pretitle">Executives</h6>
              <h1 className="header-title">General Information Sheet</h1>
            </div>
            <div className="col-auto">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => router.visit('/executives/gis_record/edit')}
              >
                Edit GIS
              </button>
            </div>
          </div>
        </div>
      </div>

      <FlashAlert variant="danger" message={flashAlert} onDismiss={() => setFlashAlert(null)} />
      <FlashAlert variant="success" message={flashNotice} textDark onDismiss={() => setFlashNotice(null)} />

      <div className="row">
        <div className="col-12 col-lg-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-header-title">Company Details</h4>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <div className="small text-body-secondary">Par Value</div>
                <div className="fw-semibold">{gisRecord?.par_value != null ? `PHP ${Number(gisRecord.par_value).toFixed(2)}` : '—'}</div>
              </div>
              <div className="mb-3">
                <div className="small text-body-secondary">Total Shares Issued</div>
                <div className="fw-semibold">{gisRecord?.total_shares_issued?.toLocaleString() || '—'}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="card">
            <div className="card-header">
              <h4 className="card-header-title">Shareholders</h4>
            </div>
            <div className="table-responsive">
              <table className="table table-sm table-hover table-nowrap card-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Birthdate</th>
                    <th>Email</th>
                    <th>Contact Number</th>
                    <th>Address</th>
                    <th className="text-end">Shares</th>
                  </tr>
                </thead>
                <tbody>
                  {shareholders.map((s, index) => (
                    <tr key={index}>
                      <td className="fw-semibold">{s.name || '—'}</td>
                      <td>{s.birthdate || '—'}</td>
                      <td>{s.email || '—'}</td>
                      <td>{s.contact_number || '—'}</td>
                      <td>{s.address || '—'}</td>
                      <td className="text-end">{s.shares_count?.toLocaleString() || '—'}</td>
                    </tr>
                  ))}

                  {!shareholders.length ? (
                    <tr>
                      <td colSpan={6} className="text-center text-body-secondary py-4">
                        No shareholders recorded.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
            {shareholders.length > 0 ? (
              <div className="card-footer">
                <div className="d-flex justify-content-between">
                  <span className="text-body-secondary">Total Shares Held</span>
                  <span className="fw-semibold">
                    {shareholders.reduce((sum, s) => sum + (s.shares_count || 0), 0).toLocaleString()}
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
